import { makePostRequest } from 'lib/axios';

const bagelSmsConsent = async (payload: {
  phoneNumber: string;
  consent: boolean;
}): Promise<any> => {
  const url = `/auth/bagel-sms-consent`;
  const response = await makePostRequest(url, payload);
  return response.data;
};

export default bagelSmsConsent;
